// components/Teachers.jsx
import { React } from "react";
import { Table, Input, Button, Modal, Form } from "antd";
import {
	PlusOutlined,
	EyeOutlined,
	EditOutlined,
	DeleteOutlined,
} from "@ant-design/icons";
import useTeachers from "../../../hooks/AdminDashboard/useTeachers";

const { Column } = Table;

function Teachers() {
	const {
		filteredTeachers,
		form,
		searchTerm,
		setSearchTerm,
		isModalVisible,
		modalType,
		showModal,
		selectedTeacher,
		handleModalConfirm,
		handleModalCancel,
	} = useTeachers();

	const renderFormContent = () => {
		switch (modalType) {
			case "view":
				return (
					<div>
						<p>
							<strong>Name:</strong>{" "}
							{selectedTeacher.fullName || ""}
						</p>
						<p>
							<strong>Email:</strong>{" "}
							{selectedTeacher.email || ""}
						</p>
						<p>
							<strong>phone Number:</strong>{" "}
							{selectedTeacher.phoneNumber || ""}
						</p>
					</div>
				);
			case "add":
				return (
					<>
						<Form.Item label="Name" name="fullName">
							<Input />
						</Form.Item>
						<Form.Item label="Email" name="email">
							<Input />
						</Form.Item>
						<Form.Item label="Password" name="password">
							<Input />
						</Form.Item>
						<Form.Item label="Phone" name="phoneNumber">
							<Input />
						</Form.Item>
					</>
				);
			case "edit":
				return (
					<>
						<Form.Item
							label="Name"
							name="fullName"
							initialValue={selectedTeacher.fullName || ""}
						>
							<Input />
						</Form.Item>
						<Form.Item
							label="Email"
							name="email"
							initialValue={selectedTeacher.email || ""}
						>
							<Input />
						</Form.Item>
						<Form.Item
							label="Phone"
							name="phoneNumber"
							initialValue={selectedTeacher.phoneNumber || ""}
						>
							<Input />
						</Form.Item>
					</>
				);
			case "delete":
				return <p>Are you sure you want to delete this Teacher?</p>;
			default:
				return null;
		}
	};

	return (
		<div className="p-6 bg-white">
			<h2 className="text-2xl font-bold mb-4">Teachers List</h2>

			{/* Search Bar */}
			<div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
				<Input.Search
					placeholder="Search by teacher name..."
					onChange={(e) => setSearchTerm(e.target.value)}
					value={searchTerm}
					className="w-full"
				/>

				{/* Add Teacher Button */}
				<Button
					type="primary"
					icon={<PlusOutlined />}
					onClick={() => showModal("add")}
					className="w-full bg-blue-500 hover:bg-blue-600 mb-4"
				>
					Add Teacher
				</Button>
			</div>

			{/* Teachers Table */}
			<Table dataSource={filteredTeachers} rowKey="_id">
				<Column title="Name" dataIndex="fullName" key="fullName" />
				<Column title="Email" dataIndex="email" key="email" />
				<Column
					title="Actions"
					key="actions"
					render={(_, record) => (
						<>
							<Button
								icon={<EyeOutlined />}
								onClick={() => showModal("view", record)}
								className="mr-2"
							/>
							<Button
								icon={<EditOutlined />}
								onClick={() => showModal("edit", record)}
								className="mr-2"
							/>
							<Button
								icon={<DeleteOutlined />}
								onClick={() => showModal("delete", record)}
								danger
							/>
						</>
					)}
				/>
			</Table>

			{/* Modal for Add/View/Edit/Delete Teacher */}
			<Modal
				title={`${
					modalType.charAt(0).toUpperCase() + modalType.slice(1)
				} Teacher`}
				open={isModalVisible}
				onCancel={handleModalCancel}
				footer={null} // Custom footer to handle form submission
			>
				<Form
					layout="vertical"
					onFinish={handleModalConfirm} // Handle submission
					initialValues={
						modalType === "edit" && selectedTeacher
							? {
									name: selectedTeacher.name,
									email: selectedTeacher.email,
									phoneNumber: selectedTeacher.phoneNumber,
									password: selectedTeacher.password,
							  }
							: {}
					}
					form={form}
				>
					{renderFormContent()}
					<Form.Item>
						<Button type="primary" htmlType="submit">
							{modalType === "delete" ? "Confirm" : "Submit"}
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
}

export default Teachers;
